import React, { useState, useEffect } from "react";
import { Card, Badge } from "react-bootstrap";
import {
  DeltaexchangeWalletData,
  Deltaexchangetransactions,
  DeltaexchangePosition,
  getAllDeltaHoldingPositionsdata,
} from "../../../Service/Broker.service.jsx";

import DataTable from "react-data-table-component";
import DeltaSocketClient from "../../../Utils/main/DeltaSocket";

import Swal from "sweetalert2";

const Wallet = () => {
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const gotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const UserNamego_localstg = JSON.parse(
    localStorage.getItem("user_details_goTo")
  );
  
  // FIXED: Store array of all wallets, not just one
  const [walletdata, setWalletdata] = useState([]);
  const [selectedAsset, setSelectedAsset] = useState('USD'); // Changed default to BTC since it might have balance
  const [positiondata, setPositiondata] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [livePrices, setLivePrices] = useState({});

  const [holding, setHolding] = useState([]);
  const [loading, setLoading] = useState({
    wallet: false,
    positions: false,
    transactions: false,
    holdings: false,
  });

  const formatNumber = (num) => {
    if (!num) return "0";
    const n = Number(num);

    // Round upto 4 decimals
    const fixed = n.toFixed(4);

    // Remove extra trailing zeros (e.g., 10.5000 → 10.5)
    return fixed.replace(/\.?0+$/, "");
  };

  // FIXED: Helper function to get currently selected wallet
  const getCurrentWallet = () => {
    if (!walletdata || walletdata.length === 0) {
      return {
        asset_symbol: 'USD',
        available_balance: '0',
        available_balance_inr: '0',
        balance: '0',
        balance_inr: '0',
        blocked_margin: '0',
        position_margin: '0',
        order_margin: '0',
        commission: '0'
      };
    }
    
    const selected = walletdata.find(w => w.asset_symbol === selectedAsset);
    return selected || walletdata[0]; // Fallback to first if selected not found
  };

  useEffect(() => {
    if (gotodashboard ? UserNamego_localstg.user_id : user_details?.user_id) {
      getWallet();
      getPosition();
      getTransaction();
      getHolding();
    } else {
      Swal.fire({
        icon: "warning",
        title: "User Not Found",
        text: "Please login again to access wallet data.",
      });
    }
  }, []);


  const getWallet = async () => {
    try {
      setLoading((prev) => ({ ...prev, wallet: true }));
      const data = {
        userid: gotodashboard
          ? UserNamego_localstg.user_id
          : user_details?.user_id,
      };
      const response = await DeltaexchangeWalletData(data);
     
      // FIXED: Store the entire array, not just first element
      if (response.result && Array.isArray(response.result)) {
        setWalletdata(response.result);
        
        // Auto-select first asset with non-zero balance, or BTC as fallback
        const assetWithBalance = response.result.find(
          w => parseFloat(w.balance || 0) > 0
        );
        if (assetWithBalance) {
          setSelectedAsset(assetWithBalance.asset_symbol);
        }
      } else {
        setWalletdata([]);
      }
    } catch (error) {
      console.error("Wallet fetch error:", error);
      setWalletdata([]);
    } finally {
      setLoading((prev) => ({ ...prev, wallet: false }));
    }
  };

  const getPosition = async () => {
    try {
      setLoading((prev) => ({ ...prev, positions: true }));
      const data = {
        userid: gotodashboard
          ? UserNamego_localstg.user_id
          : user_details?.user_id,
        product_id: "",
      };
      const response = await DeltaexchangePosition(data);
      if (response.success) {
        setPositiondata(response?.positions);
      } else {
        setPositiondata([]);
      }
    } catch (error) {
      setPositiondata([]);
    } finally {
      setLoading((prev) => ({ ...prev, positions: false }));
    }
  };

  const getTransaction = async () => {
    try {
      setLoading((prev) => ({ ...prev, transactions: true }));
      const data = {
        userid: gotodashboard
          ? UserNamego_localstg.user_id
          : user_details?.user_id,
      };
      const response = await Deltaexchangetransactions(data);
      if (response) {
        setTransactions(response?.result);
      } else {
        setTransactions([]);
      }
    } catch (error) {
      setTransactions([]);
    } finally {
      setLoading((prev) => ({ ...prev, transactions: false }));
    }
  };

  const getHolding = async () => {
    try {
      setLoading((prev) => ({ ...prev, holdings: true }));
      const data = {
        userid: gotodashboard
          ? UserNamego_localstg.user_id
          : user_details?.user_id,
      };
      const response = await getAllDeltaHoldingPositionsdata(data);
      if (response.success) {
        setHolding(response.result);
      } else {
        setHolding([]);
      }
    } catch (error) {
    } finally {
      setLoading((prev) => ({ ...prev, holdings: false }));
    }
  };

  const LoadingSpinner = () => (
    <div className="d-flex justify-content-center align-items-center py-4">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );

  useEffect(() => {
    if (!positiondata || positiondata.length === 0) return;

    const symbols = positiondata
      .map((p) => p.product_symbol || p.symbol)
      .filter(Boolean);

    if (symbols.length === 0) return;

    const client = DeltaSocketClient.instance;
    if (!client) return;

  
    symbols.forEach((symbol) => client.subscribe(symbol));

    
    symbols.forEach((symbol) => {
      const cached = client.getPrice(symbol);

      if (cached) {
        const price =
          typeof cached === "number"
            ? cached
            : cached.spot_price || cached.price || null;

        if (price) {
          setLivePrices((prev) => ({
            ...prev,
            [symbol]: price,
          }));
        }
      }
    });

    
    const handleUpdate = (data) => {
      if (!data?.symbol || !symbols.includes(data.symbol)) return;

      const price =
        typeof data.spot_price === "number"
          ? data.spot_price
          : Number(data.spot_price);

      if (!price) return;

      setLivePrices((prev) => ({
        ...prev,
        [data.symbol]: price,
      }));
    };

    const oldCallback = client.onMessageCallback;
    client.onMessageCallback = handleUpdate;

    return () => {
      client.onMessageCallback = oldCallback;
    };
  }, [positiondata]);


  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      width: "70px",
      cell: (row, index) => (
        <span
          className="badge text-dark"
          style={{
            borderRadius: "8px",
            padding: "6px 10px",
          }}
        >
          {index + 1}
        </span>
      ),
    },
    {
      name: "Date",
      grow: 2,
      selector: (row) => row.created_at,
      cell: (row) => (
        <div>
          <div
            className="fw-bold"
            style={{ color: "#2c3e50", fontSize: "14px" }}
          >
            {new Date(row?.created_at).toLocaleDateString()}
          </div>
          <small>{new Date(row?.created_at).toLocaleTimeString()}</small>
        </div>
      ),
    },
    {
      name: "Type",
      selector: (row) => row.transaction_type,
      cell: (row) => (
        <div className="d-flex align-items-center">
          <span style={{ fontSize: "16px", marginRight: "6px" }}>
            {row.transaction_type === "funding" ? "💰" : "💸"}
          </span>
          <span
            className={
              row.transaction_type === "funding"
                ? "text-success fw-bold"
                : "text-danger fw-bold"
            }
          >
            {row.transaction_type.charAt(0).toUpperCase() +
              row.transaction_type.slice(1)}
          </span>
        </div>
      ),
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
      cell: (row) => (
        <div className="d-flex align-items-center">
          <span style={{ fontSize: "16px", marginRight: "6px" }}>
            {row?.transaction_type === "funding" ? "⬆️" : "⬇️"}
          </span>

          <span
            className={
              row.transaction_type === "funding"
                ? "text-success fw-bold"
                : "text-danger fw-bold"
            }
          >
            {row.transaction_type === "funding" ? "+" : "-"} {row.asset_symbol}{" "}
            {parseFloat(row.amount ?? 0).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 8,
            })}
          </span>
        </div>
      ),
    },
    {
      name: "Product",
      selector: (row) => row?.meta_data?.product_symbol,
      cell: (row) => (
        <span className="fw-bold">{row?.meta_data?.product_symbol || "-"}</span>
      ),
    },
    {
      name: "Status",
      selector: () => "Completed",
      cell: () => (
        <span
          className="badge bg-success"
          style={{
            borderRadius: "20px",
            padding: "8px 16px",
          }}
        >
          ✅ Completed
        </span>
      ),
    },
  ];

  // Get current wallet data
  const currentWallet = getCurrentWallet();

  return (
    <div>
      <div className="container-fluid p-0">
        {/* Header */}
        <div className="mb-4">
          <h5 className="fw-bold mb-1">🔺 Delta Exchange Wallet</h5>
          <p className="mb-0">Manage your Delta Exchange trading account</p>
        </div>

        <Card
          className="shadow-lg border-0"
          style={{ borderRadius: "20px", overflow: "hidden" }}
        >
          <div
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              padding: "15px",
            }}
          >
            {/* FIXED: Asset selector dropdown */}
            {walletdata.length > 0 && (
              <div className="mb-3 text-center">
                <select
                  className="form-select form-select-lg"
                  style={{
                    maxWidth: "300px",
                    margin: "0 auto",
                    backgroundColor: "rgba(255,255,255,0.9)",
                    fontWeight: "bold",
                    borderRadius: "15px",
                    padding: "12px 20px"
                  }}
                  value={selectedAsset}
                  onChange={(e) => setSelectedAsset(e.target.value)}
                >
                  {walletdata.map((wallet) => (
                    <option key={wallet.asset_symbol} value={wallet.asset_symbol}>
                      {wallet.asset_symbol} - Balance: {formatNumber(wallet.balance)}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="row">
              <div className="col-md-4 mb-3">
                <div
                  className="text-center p-4 h-100"
                  style={{
                    backgroundColor: "rgba(255,255,255,0.15)",
                    backdropFilter: "blur(10px)",
                    borderRadius: "15px",
                    border: "1px solid rgba(255,255,255,0.2)",
                  }}
                >
                  <div className="mb-3">
                    <div
                      className="d-inline-flex align-items-center justify-content-center mb-2"
                      style={{
                        width: "60px",
                        height: "60px",
                        backgroundColor: "rgba(255,255,255,0.2)",
                        borderRadius: "50%",
                      }}
                    >
                      <span style={{ fontSize: "24px" }}>💰</span>
                    </div>
                  </div>
                  <h6 className="text-white-50 mb-2">Available Balance</h6>
                  {loading.wallet ? (
                    <div className="text-white">Loading...</div>
                  ) : (
                    <>
                      <h2 className="text-white fw-bold mb-1">
                        INR {currentWallet?.available_balance_inr || "0.00"}
                      </h2>
                      <small className="text-white-50">
                        {currentWallet?.available_balance || "0.00"}{" "}
                        {currentWallet?.asset_symbol || "USD"}
                      </small>
                    </>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div
                  className="text-center p-4 h-100"
                  style={{
                    backgroundColor: "rgba(255,255,255,0.15)",
                    backdropFilter: "blur(10px)",
                    borderRadius: "15px",
                    border: "1px solid rgba(255,255,255,0.2)",
                  }}
                >
                  <div className="mb-3">
                    <div
                      className="d-inline-flex align-items-center justify-content-center mb-2"
                      style={{
                        width: "60px",
                        height: "60px",
                        backgroundColor: "rgba(255,255,255,0.2)",
                        borderRadius: "50%",
                      }}
                    >
                      <span style={{ fontSize: "24px" }}>📊</span>
                    </div>
                  </div>
                  <h6 className="text-white-50 mb-2">Total Balance</h6>
                  {loading.wallet ? (
                    <div className="text-white">Loading...</div>
                  ) : (
                    <>
                      <h2 className="text-white fw-bold mb-1">
                        {formatNumber(currentWallet?.balance) || "0.00"}{" "}
                        {currentWallet?.asset_symbol || "USD"}
                      </h2>
                      <small className="text-white-50">
                        INR {currentWallet?.balance_inr || "0.00"}
                      </small>
                    </>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div
                  className="text-center p-4 h-100"
                  style={{
                    backgroundColor: "rgba(255,255,255,0.15)",
                    backdropFilter: "blur(10px)",
                    borderRadius: "15px",
                    border: "1px solid rgba(255,255,255,0.2)",
                  }}
                >
                  <div className="mb-3">
                    <div
                      className="d-inline-flex align-items-center justify-content-center mb-2"
                      style={{
                        width: "60px",
                        height: "60px",
                        backgroundColor: "rgba(255,255,255,0.2)",
                        borderRadius: "50%",
                      }}
                    >
                      <span style={{ fontSize: "24px" }}>🔒</span>
                    </div>
                  </div>
                  <h6 className="text-white-50 mb-2">Blocked Margin</h6>
                  {loading.wallet ? (
                    <div className="text-white">Loading...</div>
                  ) : (
                    <h2 className="text-white fw-bold mb-1">
                      {formatNumber(currentWallet?.blocked_margin)}{" "}
                      {currentWallet?.asset_symbol || "USD"}
                    </h2>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="p-3">
            {/* Position Section */}
            <div className="mb-5">
              <div className="d-flex align-items-center mb-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center me-3"
                  style={{
                    width: "50px",
                    height: "50px",
                    backgroundColor: "#fff3e0",
                    borderRadius: "15px",
                  }}
                >
                  <span style={{ fontSize: "20px" }}>📊</span>
                </div>

                <div>
                  <h5 className="mb-1 fw-bold">Active Positions</h5>
                  <small className="">Your current trading positions</small>
                </div>
              </div>

              {loading.positions ? (
                <LoadingSpinner />
              ) : positiondata.length === 0 ? (
                <div
                  className="text-center py-5"
                  style={{ borderRadius: "15px" }}
                >
                  <div style={{ fontSize: "48px", marginBottom: "16px" }}>
                    📈
                  </div>
                  <p className=" mb-0">No positions available.</p>
                </div>
              ) : (
                <div
                  className="react-bootstrap-table mb-4"
                  style={{
                    borderRadius: "15px",
                    overflow: "hidden",
                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  <table className="table mb-0">
                    <thead>
                      <tr>
                        <th
                          className="border-0 py-3 px-4"
                          style={{ fontWeight: "600", color: "#6c757d" }}
                        >
                          #
                        </th>
                        <th
                          className="border-0 py-3"
                          style={{ fontWeight: "600", color: "#6c757d" }}
                        >
                          Product Symbol
                        </th>
                        <th
                          className="border-0 py-3"
                          style={{ fontWeight: "600", color: "#6c757d" }}
                        >
                          Product ID
                        </th>
                        <th
                          className="border-0 py-3"
                          style={{ fontWeight: "600", color: "#6c757d" }}
                        >
                          Entry Price
                        </th>
                        <th
                          className="border-0 py-3"
                          style={{ fontWeight: "600", color: "#6c757d" }}
                        >
                          Size
                        </th>
                        <th
                          className="border-0 py-3"
                          style={{ fontWeight: "600", color: "#6c757d" }}
                        >
                          P&L
                        </th>
                        <th
                          className="border-0 py-3"
                          style={{ fontWeight: "600", color: "#6c757d" }}
                        >
                          Live Price
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {positiondata.map((position, index) => (
                        <tr
                          key={index}
                          style={{ borderBottom: "1px solid #f0f0f0" }}
                        >
                          <td className="py-3 px-4">
                            <span
                              className="badge text-dark"
                              style={{
                                borderRadius: "8px",
                                padding: "6px 10px",
                              }}
                            >
                              {index + 1}
                            </span>
                          </td>
                          <td className="py-3">
                            <div className="d-flex align-items-center">
                              <div
                                className="d-inline-flex align-items-center justify-content-center me-3"
                                style={{
                                  width: "35px",
                                  height: "35px",

                                  borderRadius: "50%",
                                  border: "2px solid #2196f3",
                                }}
                              >
                                <span style={{ fontSize: "12px" }}>📈</span>
                              </div>
                              <span className="fw-bold text-primary">
                                {position?.product_symbol}
                              </span>
                            </div>
                          </td>
                          <td className="py-3">
                            <Badge
                              bg="secondary"
                              style={{
                                borderRadius: "20px",
                                padding: "6px 12px",
                              }}
                            >
                              {position?.product_id}
                            </Badge>
                          </td>
                          <td className="py-3 fw-bold">
                            ${Number(position?.entry_price).toFixed(5)}
                          </td>

                          <td className="py-3">
                            <Badge
                              bg={position?.size > 0 ? "success" : "danger"}
                              style={{
                                borderRadius: "20px",
                                padding: "8px 16px",
                              }}
                            >
                              {position?.size > 0 ? "📈 Long" : "📉 Short"}{" "}
                              {Math.abs(position?.size)}
                            </Badge>
                          </td>
                          <td className="py-3">
                            {livePrices[position.product_symbol] ? (
                              (() => {
                                const live = Number(
                                  livePrices[position.product_symbol]
                                );
                                const entry = Number(position.entry_price);
                                const size =
                                  position.product_symbol == "BTCUSD"
                                    ? Number(position.size) * 0.001
                                    : position.product_symbol == "ETHUSD"
                                    ? Number(position.size) * 0.01
                                    : Number(position.size);

                                const pnl = (live - entry) * size;
                                const pnlColor =
                                  pnl >= 0 ? "text-success" : "text-danger";

                                return (
                                  <span className={`${pnlColor} fw-bold`}>
                                    {pnl >= 0 ? "+" : "-"}$
                                    {Math.abs(pnl).toFixed(2)}
                                  </span>
                                );
                              })()
                            ) : (
                              <span className="text-secondary">⏳</span>
                            )}
                          </td>

                          <td className="py-3 fw-bold text-primary">
                            {livePrices[position.product_symbol]
                              ? livePrices[position.product_symbol].toFixed(2)
                              : "⏳"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {/* Holding  Section */}
            <div className="mb-5">
              <div className="d-flex align-items-center mb-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center me-3"
                  style={{
                    width: "50px",
                    height: "50px",

                    borderRadius: "15px",
                  }}
                >
                  <span style={{ fontSize: "20px" }}>📊</span>
                </div>

                <div>
                  <h5 className="mb-1 fw-bold">Holding Positions</h5>
                  <small className="">Your Holding positions</small>
                </div>
              </div>

              {loading.positions ? (
                <LoadingSpinner />
              ) : holding?.length === 0 ? (
                <div
                  className="text-center py-5"
                  style={{ borderRadius: "15px" }}
                >
                  <div style={{ fontSize: "48px", marginBottom: "16px" }}>
                    📈
                  </div>
                  <p className=" mb-0">No Holdings Position available.</p>
                </div>
              ) : (
                <div
                  className="react-bootstrap-table mb-4"
                  style={{
                    borderRadius: "15px",
                    overflow: "hidden",
                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  <table className="table mb-0">
                    <thead>
                      <tr>
                        <th
                          className="border-0 py-3 px-4"
                          style={{ fontWeight: "600", color: "#6c757d" }}
                        >
                          #
                        </th>
                        <th
                          className="border-0 py-3"
                          style={{ fontWeight: "600", color: "#6c757d" }}
                        >
                          Product Symbol
                        </th>
                        <th
                          className="border-0 py-3"
                          style={{ fontWeight: "600", color: "#6c757d" }}
                        >
                          Product ID
                        </th>
                        <th
                          className="border-0 py-3"
                          style={{ fontWeight: "600", color: "#6c757d" }}
                        >
                          Entry Price
                        </th>
                        <th
                          className="border-0 py-3"
                          style={{ fontWeight: "600", color: "#6c757d" }}
                        >
                          Size
                        </th>
                        <th
                          className="border-0 py-3"
                          style={{ fontWeight: "600", color: "#6c757d" }}
                        >
                          Realized P&L
                        </th>
                        <th
                          className="border-0 py-3"
                          style={{ fontWeight: "600", color: "#6c757d" }}
                        >
                          Unrealized P&L
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {holding
                        ?.filter((position) => position.size !== 0)
                        .map((position, index) => (
                          <tr
                            key={`${position.product_symbol}_${position.product_id}`}
                            style={{ borderBottom: "1px solid #f0f0f0" }}
                          >
                            <td className="py-3 px-4">
                              <span
                                className="badge text-dark"
                                style={{
                                  borderRadius: "8px",
                                  padding: "6px 10px",
                                }}
                              >
                                {index + 1}
                              </span>
                            </td>
                            <td className="py-3">
                              <div className="d-flex align-items-center">
                                <div
                                  className="d-inline-flex align-items-center justify-content-center me-3"
                                  style={{
                                    width: "35px",
                                    height: "35px",

                                    borderRadius: "50%",
                                    border: "2px solid #2196f3",
                                  }}
                                >
                                  <span style={{ fontSize: "12px" }}>📈</span>
                                </div>
                                <span className="fw-bold text-primary">
                                  {position?.product_symbol}
                                </span>
                              </div>
                            </td>
                            <td className="py-3">
                              <Badge
                                bg="secondary"
                                style={{
                                  borderRadius: "20px",
                                  padding: "6px 12px",
                                }}
                              >
                                {position?.product_id}
                              </Badge>
                            </td>
                            <td className="py-3 fw-bold">
                              ${Number(position?.entry_price).toFixed(5)}
                            </td>
                            <td className="py-3">
                              <Badge
                                bg={position?.size > 0 ? "success" : "danger"}
                                style={{
                                  borderRadius: "20px",
                                  padding: "8px 16px",
                                }}
                              >
                                {position?.size > 0 ? "📈 Long" : "📉 Short"}{" "}
                                {Math.abs(position?.size)}
                              </Badge>
                            </td>
                            <td className="py-3">
                              <span
                                className={
                                  position?.size > 0
                                    ? "text-success fw-bold"
                                    : "text-danger fw-bold"
                                }
                              >
                                {position.size > 0 ? "+" : "-"}$
                                {Math.abs(position?.size) *
                                  parseFloat(position?.realized_pnl)}
                              </span>
                            </td>
                            <td className="py-3">
                              <span
                                className={
                                  position?.size > 0
                                    ? "text-success fw-bold"
                                    : "text-danger fw-bold"
                                }
                              >
                                {position.size > 0 ? "+" : "-"}$
                                {Math.abs(position?.size) *
                                  parseFloat(position?.unrealized_pnl)}
                              </span>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {/* Transactions Section */}
            <div
              className="shadow-sm"
              style={{
                borderRadius: "15px",
                overflow: "hidden",
                marginBottom: "20px",
              }}
            >
              <DataTable
                columns={columns}
                data={transactions}
                pagination
                highlightOnHover
                responsive
                customStyles={{
                  table: { style: { minWidth: "600px" } },
                }}
              />
            </div>

            {/* Wallet Details Section */}
            <div className="mb-5 mt-10">
              <div className="d-flex align-items-center mb-4 mt-10">
                <div
                  className="d-inline-flex align-items-center justify-content-center me-3 wallet-icon"
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "15px",
                  }}
                >
                  <span style={{ fontSize: "20px" }}>💳</span>
                </div>
                <div>
                  <h5 className="mb-1 fw-bold wallet-heading">
                    Wallet Details
                  </h5>
                  <small className="wallet-sub">
                    Complete wallet information
                  </small>
                </div>
              </div>

              {loading.wallet ? (
                <LoadingSpinner />
              ) : walletdata.length === 0 ? (
                <div
                  className="text-center py-5"
                  style={{ borderRadius: "15px" }}
                >
                  <div style={{ fontSize: "48px", marginBottom: "16px" }}>
                    📭
                  </div>
                  <p className=" mb-0">No wallet data available.</p>
                </div>
              ) : (
                <div
                  className="react-bootstrap-table mb-4"
                  style={{
                    borderRadius: "15px",
                    overflow: "hidden",
                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  <table className="table mb-0">
                    <thead>
                      <tr>
                        <th
                          className="border-0 py-3 px-4"
                          style={{ fontWeight: "600", color: "#6c757d" }}
                        >
                          Field
                        </th>
                        <th
                          className="border-0 py-3"
                          style={{ fontWeight: "600", color: "#6c757d" }}
                        >
                          Value
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{ borderBottom: "1px solid #f0f0f0" }}>
                        <td className="py-3 px-4">
                          <div className="d-flex align-items-center">
                            <span
                              style={{ fontSize: "16px", marginRight: "10px" }}
                            >
                              🏷️
                            </span>
                            <strong>Asset Symbol</strong>
                          </div>
                        </td>
                        <td className="py-3">
                          <Badge
                            bg="primary"
                            style={{
                              borderRadius: "20px",
                              padding: "8px 16px",
                            }}
                          >
                            {currentWallet?.asset_symbol}
                          </Badge>
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid #f0f0f0" }}>
                        <td className="py-3 px-4">
                          <div className="d-flex align-items-center">
                            <span
                              style={{ fontSize: "16px", marginRight: "10px" }}
                            >
                              💵
                            </span>
                            <strong>Available Balance</strong>
                          </div>
                        </td>
                        <td className="py-3 fw-bold text-success">
                          {Number(currentWallet?.available_balance).toFixed(5)}{" "}
                          {currentWallet?.asset_symbol}
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid #f0f0f0" }}>
                        <td className="py-3 px-4">
                          <div className="d-flex align-items-center">
                            <span
                              style={{ fontSize: "16px", marginRight: "10px" }}
                            >
                              🇮🇳
                            </span>
                            <strong>Available Balance (INR)</strong>
                          </div>
                        </td>
                        <td className="py-3 fw-bold text-success">
                          {currentWallet?.available_balance_inr}
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid #f0f0f0" }}>
                        <td className="py-3 px-4">
                          <div className="d-flex align-items-center">
                            <span
                              style={{ fontSize: "16px", marginRight: "10px" }}
                            >
                              💰
                            </span>
                            <strong>Total Balance</strong>
                          </div>
                        </td>
                        <td className="py-3 fw-bold text-primary">
                          {currentWallet?.balance} {currentWallet?.asset_symbol}
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid #f0f0f0" }}>
                        <td className="py-3 px-4">
                          <div className="d-flex align-items-center">
                            <span
                              style={{ fontSize: "16px", marginRight: "10px" }}
                            >
                              🇮🇳
                            </span>
                            <strong>Total Balance (INR)</strong>
                          </div>
                        </td>
                        <td className="py-3 fw-bold text-primary">
                          {currentWallet?.balance_inr}
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid #f0f0f0" }}>
                        <td className="py-3 px-4">
                          <div className="d-flex align-items-center">
                            <span
                              style={{ fontSize: "16px", marginRight: "10px" }}
                            >
                              🚫
                            </span>
                            <strong>Blocked Margin</strong>
                          </div>
                        </td>
                        <td className="py-3 fw-bold text-danger">
                          {Number(currentWallet?.blocked_margin).toFixed(5)}{" "}
                          {currentWallet?.asset_symbol}
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid #f0f0f0" }}>
                        <td className="py-3 px-4">
                          <div className="d-flex align-items-center">
                            <span
                              style={{ fontSize: "16px", marginRight: "10px" }}
                            >
                              📈
                            </span>
                            <strong>Position Margin</strong>
                          </div>
                        </td>
                        <td className="py-3 fw-bold text-warning">
                          {Number(currentWallet?.position_margin).toFixed(5)}{" "}
                          {currentWallet?.asset_symbol}
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid #f0f0f0" }}>
                        <td className="py-3 px-4">
                          <div className="d-flex align-items-center">
                            <span
                              style={{ fontSize: "16px", marginRight: "10px" }}
                            >
                              📋
                            </span>
                            <strong>Order Margin</strong>
                          </div>
                        </td>
                        <td className="py-3 fw-bold text-info">
                          {currentWallet?.order_margin} {currentWallet?.asset_symbol}
                        </td>
                      </tr>
                      <tr>
                        <td className="py-3 px-4">
                          <div className="d-flex align-items-center">
                            <span
                              style={{ fontSize: "16px", marginRight: "10px" }}
                            >
                              💼
                            </span>
                            <strong>Commission</strong>
                          </div>
                        </td>
                        <td className="py-3 fw-bold text-secondary">
                          {Number(currentWallet?.commission).toFixed(5)}{" "}
                          {currentWallet?.asset_symbol}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Wallet;